export const META = {
  favicon: "/favicon.ico",
  theme: "#FFFFFF",
  fbapp: "0011",
  title: "Ferreteros.app - Crea hoy tu catálogo ferretero gratis!",
  description: "Crea tu catálogo ferretero para tu Ferretería, Distribuidora ó Importadora y recibe pedidos online",
  appleicon: "/logo192.jpg",
  keywords: "tienda, negocio, online, facil, delivery, compras, ventas, ferreteria, distribuidora, importadora, ferreteros",
  author: "Ferreteros.app",
  twitter: "@",
  url: "https://ferreteros.app",
  banner: {
    url: "https://res.cloudinary.com/dmpnhivah/image/upload/v1673386608/CLOUDINARY_PRESET_HIGH/brup5eig9ntrs4cdpaqy.jpg",
    format: "image/jpeg",
    width: "1200",
    height: "630",
  },
};
